import { useAccountVerification, useQueryParam } from '@psyomics/ui-common';
import { VerificationCodeStep } from '@psyomics/ui-components';

import { useGetServiceUserQuery } from '../../account/hooks/use-get-service-user-query';

const AccountVerification = () => {
  const method = useQueryParam('method');
  const redirect = useQueryParam('redirect');
  const [serviceUser, fetching] = useGetServiceUserQuery();

  if (method !== 'email' && method !== 'phone') throw new Error('Unexpected method');

  const { deliveryAddress, handleCodeSubmit, handleResend } = useAccountVerification({
    method,
    redirect,
    serviceUser,
  });

  if (fetching) return null;
  if (!deliveryAddress) throw new Error('no delivery address');

  return <VerificationCodeStep deliveryAddress={deliveryAddress} onResend={handleResend} onSubmit={handleCodeSubmit} />;
};

export { AccountVerification };
